import React, { FC } from 'react'
import s from './MapRestMenu.module.sass'

import { TypeMenuItem } from '@widgets/Restaurant/RestMenuItem/types/menu'

import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { RestMenuItem } from '@widgets/Restaurant/RestMenuItem'
import { SectionTitle } from '@shared/ui/Layout/SectionTitle'
import { Carousel } from '@shared/ui/Layout/Carousel'
import { Title } from '@shared/ui/Typography/Title'
import useFeatureFlag from '@shared/lib/hooks/useFeatureFlag'

interface Props {
  data: TypeMenuItem[]
  className?: string
  spacingDesktop?: number
}

const MapRestMenu: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  data,
  className = '',
  spacingDesktop = 16,
  ...props
}) => {
  const isFeatureActive = useFeatureFlag('kuper')
  const items = data.filter((el) => {
    if (el.type === 'delivery' && !isFeatureActive) return false
    return true
  })

  return (
    <ErrorBoundary>
      <Carousel analytic={{ section_name: 'меню' }}>
        <div className={s.section}>
          <div className={s.header}>
            <SectionTitle className={s.title} titleComponent={<Title sizes={'h4'}>Меню</Title>} skeleton={false} />
            <Carousel.Controls />
          </div>
          <Carousel.Slider
            key={data?.length || 'menu'}
            countSlidesOnContainer={2}
            className={s.slider}
            spacingDesktop={spacingDesktop}>
            {items.map((el, index) => (
              <RestMenuItem sizes={'261x86'} key={el.id} {...el} analytic={{ section_index: index }} />
            ))}
          </Carousel.Slider>
        </div>
      </Carousel>
    </ErrorBoundary>
  )
}

export default MapRestMenu
